import React from 'react'
import '../styles/loading.css'

const Loading = () => {
  return (
    <div className='loading-container'>Loading...</div>
  )
}

export default Loading